import { AuthBindings, AuthProvider } from "@refinedev/core";
import { TOKEN_KEY } from "./constants/common";
import apiHelper from "api/apiHelper";
import { getUserData } from "api/userData";
import { UserIdentityData } from "types/props";

export const authProvider: AuthProvider = {
  login: async ({ role = "", token }) => {
    if (role === "user") {
      localStorage.setItem(TOKEN_KEY, token);
      // localStorage.setItem(ROLE_KEY, 'cb7pccv87bcnp9cbp');
      return {
        success: true,
        redirectTo: "/jobs"
      };
    }
    if (role === "admin") {
      localStorage.setItem(TOKEN_KEY, token);
      return {
        success: true,
        redirectTo: "/admin/jobs-overview"
      };
    }

    return {
      success: false
    };
  },

  logout: async () => {
    try {
      await apiHelper.post("/auth/logout", {});
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem("user");
      return {
        success: true
      };
    } catch {
      return {
        success: false,
        error: {
          name: "Logout error",
          message: "Logout failed."
        }
      };
    }
  },

  check: async () => {
    const user = await getUserData();
    if (user && user.role && !user.isBlocked && !user.deleted && user.verified) {
      const isAdmin = user.role.type === "admin";

      if (typeof localStorage !== "undefined") {
        localStorage.setItem("user", JSON.stringify(user));
      }

      if (isAdmin) {
        return {
          authenticated: true
        };
      }

      if (!user.approved) {
        return {
          authenticated: false,
          logout: true,
          redirectTo: "/account-pending"
        };
      }

      return {
        authenticated: true
      };
    }

    return {
      authenticated: false,
      logout: true,
      redirectTo: "/login",
      error: {
        message: "Check failed",
        name: "Unauthorized"
      }
    };
  },

  getIdentity: async () => {
    let user: UserIdentityData | undefined;
    const userJson = localStorage.getItem("user");
    if (userJson) {
      try {
        user = JSON.parse(userJson) as UserIdentityData;
      } catch (error) {
        console.error("Error parsing user from local storage", error);
      }
    }

    return user;
  },

  onError: async (error) => {
    console.error(error);
    return { error };
  }
};
